import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigInterface } from './config.interface';

@Injectable()
export class ConfigService {
  private readonly http = inject(HttpClient);

  loadConfig(): Observable<ConfigInterface> {
    return this.http.get<ConfigInterface>(`assets/confs/${window.location.hostname}.config.json`);
  }
}
